module.exports = __webpack_public_path__ + "static/media/Thor 1.ac904392.jpg";